import {Typography} from "@mui/material";
import {observer} from "mobx-react-lite";
import {B} from "../../build";
import {useStores} from "../../stores";
import {environment} from "../../env";

export const MainFooter = observer(() => {
    const {p, authStore} = useStores();

    // const taxonomyPath = tryGeneratePath(params, "cleanup_taxonomy_builder", bagStore.bag?.id);
    // if (location.pathname === taxonomyPath && environment.package === 'sales_demo') {
    //     // Disable the footer for the taxonomy builder while CAT-3124 is not solved
    //     return <></>
    // }

    if (!authStore.isMithraStaffGroup) {
        return null;
    }

    return <Typography
        id="main-footer"
        className="mithra-footer"
        variant="body1"
        sx={{
            color: (theme) => theme.palette.grey[200],
            marginTop: 'auto',
            marginBottom: 2,
            display: 'flex',
            justifyContent: "center",
            alignItems: "center",
        }}>
        version: {B.APP_VERSION}
        {B.APP_ENVIRONMENT === 'demo' &&
            <>
                {/*Show the gcp project in demo environment*/}
                {' - '}
                {B.FIREBASE_PROJECT_ID}
            </>
        }
        {p.p.enableBackendStatusPage && environment.statusPageUrl &&
            <>
                {' - '}
                <a style={{marginLeft: '.3em'}} href={environment.statusPageUrl} target="_blank" rel="noreferrer">
                    service status
                </a>
            </>
        }
    </Typography>;
});
